export default "__VITE_ASSET__DpAu6LVx__"